{
  "app": {
    "name": "Fly",
    "tagline": "Aero fleet management"
  },
  "nav": {
    "dashboard": "Dashboard",
    "organisation": "Organisation",
    "profile": "Profile",
    "school": "Flight school",
    "airport": "Airport",
    "members": "Members",
    "staff": "Staff",
    "aircraft": "Aircraft",
    "fleet": "Fleet",
    "logbook": "Logbook",
    "maintenance": "Maintenance",
    "alerts": "Alerts",
    "settings": "Settings",
    "taxonomies": "Configuration lists",
    "admin": "Administration",
    "counters": "Counters",
    "documents": "Documents"
  },
  "action": {
    "save": "Save",
    "cancel": "Cancel",
    "create": "Create",
    "edit": "Edit",
    "delete": "Delete",
    "close": "Close",
    "search": "Search",
    "filter": "Filter",
    "clear": "Clear",
    "export": "Export",
    "exportPdf": "Export PDF",
    "exportXlsx": "Export Excel",
    "refresh": "Refresh",
    "add": "Add",
    "acknowledge": "Acknowledge",
    "acknowledgeAll": "Acknowledge all",
    "snooze": "Snooze",
    "resolve": "Resolve",
    "certify": "Certify",
    "correct": "File a correction",
    "complete": "Complete",
    "reopen": "Reopen",
    "signIn": "Sign in",
    "signOut": "Sign out",
    "retry": "Try again",
    "back": "Back",
    "viewAll": "View all",
    "upload": "Upload",
    "download": "Download",
    "adjust": "Adjust",
    "recompute": "Recompute",
    "startWork": "Start work",
    "revalidate": "Revalidate",
    "confirm": "Confirm"
  },
  "auth": {
    "signInTitle": "Sign in",
    "signInSubtitle": "Aero fleet management for your club",
    "email": "Email address",
    "password": "Password",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "changePassword": "Change password",
    "passwordChanged": "Your password has been changed.",
    "signInFailed": "Incorrect email address or password.",
    "passwordTooShort": "Use at least 10 characters.",
    "passwordMismatch": "The two passwords do not match.",
    "noOrganisation": "Your account is not a member of any organisation yet. Ask an administrator to add you.",
    "sessionExpired": "Your session has expired. Please sign in again."
  },
  "common": {
    "yes": "Yes",
    "no": "No",
    "none": "None",
    "all": "All",
    "loading": "Loading",
    "noResults": "Nothing to show",
    "noResultsHint": "Try widening the filters.",
    "error": "Something went wrong",
    "serverUnavailable": "The server is temporarily unavailable. Please try again in a few minutes.",
    "total": "Total",
    "totals": "Totals",
    "summary": "Summary",
    "status": "Status",
    "date": "Date",
    "from": "From",
    "to": "To",
    "notes": "Notes",
    "remarks": "Remarks",
    "name": "Name",
    "actions": "Actions",
    "active": "Active",
    "inactive": "Inactive",
    "validUntil": "Valid until",
    "validFrom": "Valid from",
    "daysRemaining": "Days remaining",
    "language": "Language",
    "theme": "Theme",
    "light": "Light",
    "dark": "Dark",
    "auto": "System",
    "organisation": "Organisation",
    "switchOrganisation": "Switch organisation",
    "hours": "hours",
    "minutes": "minutes",
    "count": "count",
    "days": "days",
    "of": "of",
    "page": "Page",
    "rowsPerPage": "Rows per page",
    "showingRange": "{{from}}–{{to}} of {{count}}",
    "unsavedChanges": "You have unsaved changes.",
    "confirmDelete": "Delete this permanently?",
    "requiredField": "This field is required."
  },
  "dashboard": {
    "title": "Dashboard",
    "fleetStatus": "Fleet status",
    "airworthy": "Airworthy",
    "grounded": "Grounded",
    "inMaintenance": "In maintenance",
    "flightsThisYear": "Flying recorded",
    "openAlerts": "Open alerts",
    "overdueMaintenance": "Overdue maintenance",
    "uncertifiedFlights": "Flights awaiting certification",
    "people": "People",
    "pilots": "Pilots",
    "students": "Student pilots",
    "recentFlights": "Recent flights",
    "expiringDocuments": "Expiring documents",
    "monthlyFlying": "Flying by month",
    "noFlightsYet": "No flights recorded yet."
  },
  "organisation": {
    "kind": "Kind",
    "CLUB": "Aero club",
    "FLIGHT_SCHOOL": "Flight school",
    "AIRPORT": "Airport",
    "headInstructor": "Head instructor",
    "headOfTraining": "Head of training",
    "safetyManager": "Safety manager",
    "airportManager": "Airport manager",
    "icaoCode": "ICAO code",
    "iataCode": "IATA code",
    "localIdentifier": "Local identifier",
    "elevation": "Elevation (ft)",
    "runways": "Runways",
    "radioFrequency": "Radio frequency",
    "operatingHours": "Operating hours",
    "approvalType": "Approval type",
    "approvalNumber": "Approval number",
    "competentAuthority": "Competent authority",
    "approvedCourses": "Approved courses",
    "logo": "Logo",
    "primaryColor": "Primary colour",
    "registrationNumber": "Registration number",
    "foundedYear": "Founded in",
    "membershipNumber": "Membership number",
    "postalCode": "Postal code",
    "roles": "Roles",
    "website": "Website"
  },
  "staff": {
    "title": "Staff",
    "person": "Person",
    "people": "People",
    "firstName": "First name",
    "lastName": "Last name",
    "dateOfBirth": "Date of birth",
    "nationality": "Nationality",
    "phone": "Phone",
    "email": "Email",
    "pilotStatus": "Status",
    "PILOT": "Pilot",
    "STUDENT_PILOT": "Student pilot",
    "INACTIVE": "Not flying",
    "GROUND_STAFF": "Ground staff",
    "TECHNICIAN": "Technician",
    "WINCH_OPERATOR": "Winch operator",
    "ADMINISTRATION": "Administration",
    "MEMBER": "Member",
    "EXTERNAL": "External",
    "licences": "Licences",
    "ratings": "Ratings and privileges",
    "medical": "Medical",
    "medicals": "Medical certificates",
    "language": "Language proficiency",
    "certificates": "Certificates",
    "currency": "Currency",
    "documents": "Documents",
    "logbook": "Logbook",
    "totals": "Totals",
    "licenceNumber": "Licence number",
    "issuingAuthority": "Issuing authority",
    "icaoLevel": "ICAO level",
    "scan": "Scanned copy",
    "limitations": "Limitations",
    "examiner": "Examiner",
    "instructor": "Instructor",
    "soloAuthorised": "Authorised for solo flight",
    "authorisations": "Instructor authorisations",
    "isCurrent": "In currency",
    "notCurrent": "Out of currency",
    "VALID": "Valid",
    "EXPIRING": "Expiring soon",
    "EXPIRED": "Expired",
    "MISSING": "Missing",
    "SUSPENDED": "Suspended",
    "blockingItems": "Blocks flying",
    "baselineHours": "Hours carried forward",
    "addPerson": "Add a person",
    "address": "Address",
    "city": "City",
    "emergencyContact": "Emergency contact",
    "staffKindsHint": "What this person does at the club.",
    "addLicence": "Add a licence",
    "addRating": "Add a rating",
    "addMedical": "Add a medical certificate",
    "addLanguage": "Add a language assessment",
    "addCertificate": "Add a certificate",
    "addCurrencyRule": "Add a currency rule",
    "noLicences": "No licences on file",
    "noRatings": "No ratings on file",
    "noMedical": "No medical certificate on file",
    "noLanguage": "No language assessment on file",
    "noCertificates": "No certificates on file",
    "noCurrencyRules": "No currency rules apply to this person yet",
    "currencyRule": "Currency rule",
    "metric": "What is measured",
    "comparison": "Comparison",
    "soloAuthorisedUntil": "Solo authorisation valid until",
    "threshold": "Threshold",
    "warnMargin": "Warn within",
    "blocksFlying": "Out of currency blocks flying",
    "appliesToStatus": "Applies to",
    "clubDefault": "Club default",
    "personalOverride": "Set for this person",
    "measured": "Measured",
    "revalidatedOn": "Revalidated on",
    "examinationDate": "Examination date",
    "completedOn": "Completed on",
    "suspended": "Suspended",
    "warningDays": "Warn this many days before expiry",
    "ctrEntry": "Permits entry into controlled airspace",
    "derivedExpiryHint": "Leave empty to let the system work it out from the rules.",
    "expiringDocuments": "Expiring documents"
  },
  "aircraft": {
    "title": "Aircraft",
    "fleet": "Fleet",
    "registration": "Registration",
    "competitionNumber": "Competition number",
    "type": "Type",
    "category": "Category",
    "class": "Class",
    "manufacturer": "Manufacturer",
    "model": "Model",
    "variant": "Variant",
    "serialNumber": "Serial number",
    "yearOfManufacture": "Year of manufacture",
    "seats": "Seats",
    "mtow": "MTOW (kg)",
    "engineCount": "Engines",
    "multiPilot": "Certified for multi-pilot operation",
    "canTow": "Can tow sailplanes",
    "homeBase": "Home base",
    "operator": "Operator",
    "owner": "Owner",
    "status": "Status",
    "AIRWORTHY": "Airworthy",
    "IN_MAINTENANCE": "In maintenance",
    "GROUNDED": "Grounded",
    "STORED": "Stored",
    "SOLD": "Sold",
    "groundedReason": "Reason",
    "launchCapabilities": "Launch methods",
    "components": "Components",
    "counters": "Counters",
    "maintainers": "Maintainers",
    "airframeHours": "Airframe hours",
    "landings": "Landings",
    "launches": "Launches",
    "counterHistory": "Counter history",
    "currentValue": "Current reading",
    "initialValue": "Initial reading",
    "adjustCounter": "Adjust reading",
    "adjustCounterHint": "Enter what the instrument actually reads. The change is recorded with your name against it.",
    "airworthiness": "Airworthiness",
    "cannotFly": "This aircraft may not fly",
    "addAircraft": "Add an aircraft",
    "icaoHint": "ICAO type designator"
  },
  "logbook": {
    "title": "Logbook",
    "AIRCRAFT": "Aircraft logbook",
    "PILOT": "Pilot logbook",
    "CLUB": "Club logbook",
    "SCHOOL": "Flight school logbook",
    "AIRPORT": "Movement log",
    "fileFlight": "File a flight",
    "editFlight": "Edit flight",
    "date": "Date",
    "departurePlace": "Departure",
    "departureTime": "Time out",
    "arrivalPlace": "Arrival",
    "arrivalTime": "Time in",
    "aircraft": "Aircraft",
    "aircraftType": "Aircraft type",
    "registration": "Registration",
    "singlePilotSe": "SP single-engine",
    "singlePilotMe": "SP multi-engine",
    "multiPilot": "Multi-pilot",
    "se": "SE",
    "me": "ME",
    "mp": "MP",
    "totalTime": "Total time",
    "flights": "Flights",
    "landings": "Landings",
    "uncertifiedOnly": "Awaiting certification",
    "noFlights": "No flights in this logbook",
    "noFlightsHint": "File a flight, or widen the date range.",
    "picName": "Name of PIC",
    "landingsDay": "Landings day",
    "landingsNight": "Landings night",
    "night": "Night",
    "ifr": "IFR",
    "instrument": "Instrument",
    "crossCountry": "Cross-country",
    "pic": "PIC",
    "copilot": "Co-pilot",
    "dual": "Dual",
    "instructorTime": "FI",
    "purpose": "Purpose",
    "crew": "Crew and occupants",
    "addCrew": "Add a person",
    "function": "Function",
    "timeLogged": "Time logged",
    "underTraining": "Counts towards a course",
    "tmgSplitHint": "Engine time plus gliding time must equal the total time of flight.",
    "countersign": "Countersign",
    "countersignedBy": "Countersigned by",
    "launchMethod": "Launch method",
    "launches": "Launches",
    "tug": "Tug",
    "tugPilot": "Tug pilot",
    "maxAltitude": "Max altitude (m)",
    "distance": "Distance (km)",
    "motorTime": "Engine running",
    "glidingTime": "Gliding",
    "heaterTime": "Burner time",
    "heatingType": "Heating",
    "school": "Flight school",
    "isPaid": "Charged to the participant",
    "endorsements": "Endorsements",
    "state": "State",
    "DRAFT": "Draft",
    "FILED": "Filed",
    "CERTIFIED": "Certified",
    "CORRECTED": "Superseded",
    "certifyConfirm": "Certifying locks this entry. Afterwards it can only be changed by filing a correction.",
    "correctionReason": "Reason for the correction",
    "cancelReason": "Reason for cancelling",
    "counterMovements": "Counter movements",
    "runningTotal": "Running total",
    "broughtForward": "Brought forward",
    "thisPage": "This page",
    "carriedForward": "Carried forward",
    "durationHint": "Enter as 1:25, or as decimal hours.",
    "picUppercaseHint": "The pilot in command is shown in capitals, as a Part-FCL logbook page requires.",
    "pendingCertification": "{{count}} entries await certification",
    "noPersonLinked": "Your account is not linked to a person record, so it has no pilot logbook yet.",
    "timeExceedsFlight": "Time logged cannot exceed the total time of flight."
  },
  "maintenance": {
    "title": "Maintenance",
    "programme": "Programme",
    "tasks": "Tasks",
    "task": "Task",
    "due": "Due",
    "dueList": "What is due",
    "log": "Maintenance log",
    "events": "Work records",
    "templates": "Templates",
    "area": "Area",
    "AIRFRAME": "Airframe",
    "ENGINE": "Engine",
    "PROPELLER": "Propeller",
    "AVIONICS": "Avionics",
    "EQUIPMENT": "Equipment",
    "ADMINISTRATION": "Administration",
    "referenceHint": "AMM / SB / AD",
    "camo": "CAMO",
    "interval": "Interval",
    "counterInterval": "Counter interval",
    "calendarMonths": "Calendar interval (months)",
    "tolerance": "Tolerance",
    "warnBefore": "Warn before",
    "lastDone": "Last done",
    "dueAtCounter": "Due at",
    "dueOn": "Due on",
    "remaining": "Remaining",
    "OK": "In date",
    "DUE_SOON": "Due soon",
    "DUE": "Due now",
    "IN_TOLERANCE": "In tolerance",
    "OVERDUE": "Overdue",
    "groundsAircraft": "Grounds the aircraft",
    "performedBy": "Performed by",
    "performedOn": "Performed on",
    "releasedBy": "Released to service by",
    "releaseReference": "Release reference",
    "findings": "Findings",
    "partsUsed": "Parts used",
    "cost": "Cost",
    "currency": "Currency",
    "countersAtWork": "Counter readings",
    "comments": "Comments",
    "addComment": "Add a comment",
    "attachments": "Attachments",
    "DRAFT": "Draft",
    "OPEN": "In progress",
    "DONE": "Completed",
    "CANCELLED": "Cancelled",
    "newEvent": "Record maintenance",
    "populateProgramme": "Add standard tasks",
    "populateHint": "Adds the checks this aircraft's category normally has. Existing tasks are left alone.",
    "requiresRelease": "This work needs a release to service before it can be signed off.",
    "fleetOverview": "Fleet maintenance"
  },
  "alerts": {
    "title": "Alerts",
    "rules": "Rules",
    "rule": "Rule",
    "events": "Alerts",
    "notifications": "Notifications",
    "metric": "What to watch",
    "subject": "Subject",
    "threshold": "Threshold",
    "thresholdMode": "Threshold type",
    "leadTimes": "Warn me at",
    "leadTimesHint": "One or more distances before the due point, for example 10, 5 and 1 hour.",
    "severity": "Severity",
    "INFO": "Information",
    "WARNING": "Warning",
    "CRITICAL": "Critical",
    "channels": "How to tell me",
    "IN_APP": "In the app",
    "EMAIL": "Email",
    "recipients": "Who to tell",
    "escalate": "Turn critical once overdue",
    "cooldown": "Minimum hours between notifications",
    "state": "State",
    "ACTIVE": "Active",
    "ACKNOWLEDGED": "Acknowledged",
    "SNOOZED": "Snoozed",
    "RESOLVED": "Resolved",
    "firedAt": "Raised",
    "currentReading": "Current reading",
    "newRule": "New alert rule",
    "snoozeFor": "Snooze for",
    "snoozeHours": "{{count}} hours",
    "noAlerts": "Nothing needs your attention.",
    "unacknowledged": "{{count}} unacknowledged",
    "evaluateNow": "Check now",
    "willReach": "Will reach",
    "metricParameter": "Which counter",
    "metricParameterHint": "The counter key this rule watches, for example AIRFRAME_HOURS."
  },
  "settings": {
    "title": "Settings",
    "myProfile": "My profile",
    "preferences": "Preferences",
    "taxonomies": "Configuration lists",
    "licenceTypes": "Licence types",
    "ratingTypes": "Ratings and privileges",
    "certificateTypes": "Certificate types",
    "medicalClasses": "Medical classes",
    "maintenanceTemplates": "Maintenance templates",
    "roles": "Roles",
    "users": "Users",
    "discipline": "Discipline",
    "POWERED": "Powered flying",
    "GLIDING": "Gliding",
    "BALLOON": "Ballooning",
    "HELICOPTER": "Helicopters",
    "AIRSHIP": "Airships",
    "GENERAL": "General",
    "globalEntry": "Supplied with the product",
    "clubEntry": "Added by your club",
    "code": "Code",
    "shortName": "Short name",
    "validityMonths": "Validity (months)",
    "sortOrder": "Sort order",
    "taxonomyHint": "These lists are edited in the administration area, where each name can be written in both languages."
  }
}
